/**
 * EmailPage - Pagina principal do modulo de Email
 * Extrai conversationId da URL e delega para TroiaEmailPage
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { TroiaEmailPage } from '../troia/pages/TroiaEmailPage';

export const EmailPage: React.FC = () => {
  const { conversationId } = useParams<{ conversationId?: string }>();
  const navigate = useNavigate();

  const handleSelectConversation = (id: string) => {
    navigate(`/email/${id}`, { replace: true });
  };

  const handleClearSelection = () => {
    navigate('/email', { replace: true });
  };

  return (
    <TroiaEmailPage
      conversationId={conversationId}
      onSelectConversation={handleSelectConversation}
      onClearSelection={handleClearSelection}
    />
  );
};

EmailPage.displayName = 'EmailPage';
